import { useState } from "react";

export const FoundedByYou = () => {
  return (
    <div className="section">
      <div className="container">
        <div className="text-center out-fit-title-text-mini">
          The project is Founded by you
        </div>

        {/* <div className="text-center out-fit-detail-text mt-20">
          There are 2 collections. Homies gen0 and Homies gen1. If you are
          seeing this it means you are invited to help in founding the project.
          We have the tool built but we need you to make it alive. The 500
          Homies of gen0 is the 500 founders with an EPIC following of 2250
          Homies of gen1.
        </div> */}
        <div className="founded-text">
          <div className="text-center out-fit-detail-text mt-20">
            There are 2 collections. Homies gen0 and Homies gen1. If you are
            seeing this it means you are invited to help in founding the
            project. We have the tool built but we need you to make it alive.
            The 500 Homies of gen0 is the 500 founders with an EPIC following of
            2250 Homies of gen1.
          </div>{" "}
        </div>
      </div>
      <div className="section">
        <GenZeroSlide position={true} />
        <div className="mt-20"></div>
        <GenOneSlide position={false} />
      </div>
    </div>
  );
};

type SLIDE_TYPES = {
  position: boolean;
};

export const GenZeroSlide = ({ position }: SLIDE_TYPES) => {
  const [arrayPicId, setArrayPicId] = useState<any>([]);
  return (
    <div>
      <div className="position-gen">
        <div className="position-text-zero">
          <div className="out-fit-title-text-subtitle-3 text-gen-0">GEN 0</div>{" "}
        </div>
      </div>
      <div className="slider">
        <div className={position ? "slide-track" : "slide-track-2"}>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>

          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
        </div>
      </div>
    </div>
  );
};

export const GenOneSlide = ({ position }: SLIDE_TYPES) => {
  const [arrayPicId, setArrayPicId] = useState<any>([]);
  return (
    <div>
      <div className="slider">
        <div className={position ? "slide-track" : "slide-track-2"}>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>

          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
          <div className="slide"></div>
        </div>
      </div>

      <div className="position-gen">
        <div className="position-text-one">
          <div className="out-fit-title-text-subtitle-3 text-gen-1">GEN 1</div>{" "}
        </div>
      </div>
    </div>
  );
};

export const EachImage = () => {
  return <div></div>;
};
